<template>
  <div class="view-machine">
    <div class="pad flex">
      <div class="flex-1">
        <back-button />
      </div>
      <button v-if="this.machine" class="button is-small" @click="$router.push(`/view-machine-report/${machine._id}`)">View  Report</button>
    </div>

    <div class="columns">
      <div class="column">
        <div class="box" v-if="machine">
          <div class="flex">
            <h1 class="flex-1 title is-4">{{ machine.name }}</h1>
            <button class="button is-small" @click="$router.push(`/edit-machine/${machineId}`)">
              <font-awesome-icon icon="edit" />
            </button>
          </div>

          <div class="detail">
            <div class="key">{{ machine.units | prettyUnits }}</div>
            <div class="value">
              {{ machine.smu | prettyNumber }} {{ machine.units }}
              <span v-if="machine.timestampSmuUpdated > 0" class="has-text-grey-light">
                ({{ machine.timestampSmuUpdated | unixToDateString }})
              </span>
            </div>
          </div>

          <div class="detail">
            <div class="key">Service Interval</div>
            <div class="value">{{ machine.serviceInterval | prettyNumber }} {{ machine.units }}</div>
          </div>

          <div class="detail">
            <div class="key">Service Warning</div>
            <div class="value">{{ machine.serviceWarning | prettyNumber }} {{ machine.units }} to next service</div>
          </div>

          <div class="detail">
            <div class="key">Next Service</div>
            <div class="value">
              {{ machine.nextService | prettyNumber }} {{ machine.units }}
              <b-tag :type="serviceMsgType" size="is-small">{{ serviceMsg}}</b-tag>
              <div class="extra-info" v-if="machine.typeOfService.length">
                {{ machine.typeOfService }}
              </div>
            </div>
          </div>

          <div class="detail" v-for="(d, i) in machine.otherDetails" :key="i">
            <div class="key">{{ d.key }}</div>
            <div class="value">{{ d.value }}</div>
          </div>

          <div class="detail" v-if="machine.description && machine.description.length">
            <div class="key">Descriptoin / Notes</div>
            <div class="value">{{ machine.description }}</div>
          </div>

          <div class="margin-top-20 bold" v-if="machine.hireOut">
            CAN BE HIRED OUT
          </div>

        </div>
      </div>

      <div class="column">
        <div class="box has-list">
          <repairs :machine="machine" />
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="box has-list">
          <service-history :machine="machine" />
        </div>
      </div>
      <div class="column">
        <div class="box has-list">
          <pre-start-history :machine="machine" :limit="10" />
        </div>
      </div>
    </div>

    <div v-if="machine === null">
      <font-awesome-icon icon="spinner" size="3x" pulse />
    </div>

    <b-message type="is-danger" v-if="errArr.length">
      <p v-for="(msg, i) in errArr" :key="i">{{ msg }}</p>
    </b-message>
  </div>
</template>

<script>
import ServiceHistory from '@/components/ServiceHistory'
import Repairs from '@/components/Repairs'
import PreStartHistory from '@/components/PreStartHistory'
export default {
  name: 'ViewMachine',
  components: {
    ServiceHistory,
    Repairs,
    PreStartHistory
  },
  data () {
    return {
      machine: null,
      machineId: null,
      errArr: []
    }
  },
  computed: {
    serviceDue () {
      return this.machine.smu >= (this.machine.nextService - this.machine.serviceWarning)
    },
    serviceOverDue () {
      return this.machine.smu > this.machine.nextService
    },
    serviceMsg () {
      if (!this.machine) return '?'
      let d = Math.abs(this.machine.smu - this.machine.nextService)
      // let d = this.$options.filters.prettyUnits(Math.abs(this.machine.smu - this.machine.nextService))
      if (this.serviceOverDue) {
        return `service over due ${d} ${this.machine.units}`
      } else if (this.serviceDue) {
        return `service due in ${d} ${this.machine.units}`
      } else {
        return `service in ${d} ${this.machine.units}`
      }
    },
    serviceMsgType () {
      if (this.serviceOverDue) {
        return 'is-danger'
      } else if (this.serviceDue) {
        return 'is-warning'
      } else {
        return 'is-light'
      }
    }
  },
  watch: {
    machineId () {
      this.unsub('machines')
      this.subs.machines = this.$firestore.collection('machines')
        .doc(this.machineId)
        .onSnapshot(snapshot => {
          this.machine = this.$utils.snapshotToObj(snapshot)
          if (isNaN(this.machine.serviceWarning)) {
            this.machine.serviceWarning = 0
          }
        })
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.machineId = to.params.id
    next()
  },
  created () {
    this.machineId = this.$route.params.id
  },
  methods: {
  }
}
</script>

<style>
  .view-machine .detail {
    margin-bottom: 10px;
  }
  .view-machine .detail:last-child {
    margin-bottom: 0;
  }

  .view-machine .detail.danger {
    color: red;
  }

  .view-machine .detail .key {
    font-weight: bold;
    font-size: 0.9em;
  }

  .view-machine .detail .value {
    font-size: 1.2em;
  }

  .view-machine .detail .extra-info {
    padding-left: 10px;
    font-size: 0.9em;
    color: #999;
  }

  .view-machine .box.has-list {
    padding: 0 0 4px 0;
  }
  /* .view-machine .box.has-list .title {
    margin: 0;
    padding: 1.25rem;
    padding-bottom: 10px;
  } */
</style>
